export const arrayToSelectOptions = ({
  values,
  labelKey = 'id'
}: {
  values: Array<string>;
  labelKey?: string;
}): Array<any> => {
  if (!values) return [];
  return values.map((value: string) => ({
    [labelKey]: value
  }));
};
export const stringToSelectOption = ({
  value,
  labelKey = 'id',
  valueKey = 'value'
}: {
  value: string;
  labelKey?: string;
  valueKey?: string;
}) => {
  if (value) {
    const valueObj = {
      [labelKey]: value
    };
    if (valueKey) {
      valueObj[valueKey] = value;
    }
    return [valueObj];
  }
  return [];
};